var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgReport = function SvgReport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    fill: "none",
    viewBox: "0 0 19 24",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    fillRule: "evenodd",
    d: "M17.234 7.733a1.105 1.105 0 0 0-1.105 1.105v6.629h-4.42a1.105 1.105 0 0 0-1.104 1.104v4.42H3.976a1.046 1.046 0 0 1-1.105-1.105V3.314A1.046 1.046 0 0 1 3.976 2.21H9.5A1.105 1.105 0 1 0 9.5 0L4.072.007a3.323 3.323 0 0 0-3.41 3.307v16.572A3.24 3.24 0 0 0 3.976 23.2h7.734c.293 0 .575-.117.782-.325l5.523-5.523a1.12 1.12 0 0 0 .323-.78V8.838a1.105 1.105 0 0 0-1.105-1.104m-2.668 9.943-1.752 1.753v-1.753zM10.606 3.314a1.105 1.105 0 1 0 0 2.21h2.21v2.21a1.105 1.105 0 1 0 2.209 0v-2.21h2.21a1.105 1.105 0 0 0 0-2.21h-2.21v-2.21a1.105 1.105 0 1 0-2.21 0v2.21zM6.28 8.838h3.314a1.105 1.105 0 1 0 0-2.21H6.28a1.105 1.105 0 1 0 0 2.21m0 4.42h6.628a1.105 1.105 0 1 0 0-2.21H6.281a1.105 1.105 0 1 0 0 2.21",
    clipRule: "evenodd"
  })));
};
export default SvgReport;